__turbopack_context__.v({
  "inner": "catalog-grid-loader-module-scss-module__jxGOqG__inner",
  "item": "catalog-grid-loader-module-scss-module__jxGOqG__item",
});
